export default __webpack_public_path__ + "47018a26649ceb9c2205598be74c7257.png";